export default __webpack_public_path__ + "static/media/Chevron.e94e1454.svg";